import React from 'react';
import ClassNames from 'classnames';
var Footer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    links = _ref.links,
    content = _ref.content,
    style = _ref.style,
    className = _ref.className,
    renderFooterItem = _ref.renderFooterItem;
  var classes = ClassNames('ap-footer', className);
  return /*#__PURE__*/React.createElement("footer", {
    id: id,
    className: classes,
    style: style,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-footer-content",
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), type === 'links' && links && links.length && /*#__PURE__*/React.createElement("div", {
    className: "ap-footer-link-group"
  }, links.map(function (item, index) {
    return renderFooterItem ? renderFooterItem(item, index) : /*#__PURE__*/React.createElement("div", {
      className: "ap-footer-link",
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      className: "ap-link",
      href: item.href,
      target: item.target ? item.target : '_blank'
    }, item.name), /*#__PURE__*/React.createElement("span", {
      className: "ap-footer-divider"
    }, "|"));
  })));
});
Footer.displayName = 'Footer';
export default Footer;